import { config } from '../../../config';

export const getHrefWithoutInternalOrigin = (href: string): string => {
  const internalOriginUrl = config.app.internalOriginUrl;

  if (!href) {
    return href;
  }

  if (internalOriginUrl && href.startsWith(internalOriginUrl)) {
    const trimmedHref = href.slice(internalOriginUrl.length);
    return trimmedHref || '/';
  }

  return href;
};
